//@flow
import _ from 'underscore';

import type ProductsCollection from '../../Stores/Products/productsCollection';
import type StockCollection from '../../Stores/Stock/stockCollection';
import type { UpsellProduct } from '../../Stores/Products/productModel';

class UpsellUtils {
  getUpsellProductDataFromSku(sku:string, quoteSkus:string[], stock:StockCollection, products:ProductsCollection):?UpsellProduct {
    const product = products.getProductBySku(sku);
    const upsellData = product && product.getUpsellData();
    return _.find(upsellData, (data) => {
      const upsellProduct = products.getProductBySku(data.sku);
      return !!upsellProduct && !quoteSkus.includes(data.sku) && stock.inStock(data.sku);
    });
  }
}

export default new UpsellUtils();
